import { API_URL, createRequestActionTypes } from "../../../actions";

export const FORGOT_PASSWORD_URL = `${API_URL}/api/auth/forgot_password`;
export const RESET_PASSWORD_URL = `${API_URL}/api/auth/reset_password`;
export const forgotPasswordActionTypes = {
    forgotPassword: createRequestActionTypes('FORGOT_PASSWORD'),
    resetPassword: createRequestActionTypes('RESET_PASSWORD'),
    clearErrorMsg: createRequestActionTypes('CLEAR_ERROR_MSG'),
    clearSuccessMsg: createRequestActionTypes('CLEAR_SUCCESS_MSG'),
}